module.exports = __webpack_public_path__ + "assets/img/news (2).f92df295.png";